// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"letters-b"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M8 12V5H15C15.5523 5 16 5.44772 16 6V12M8 12H16M8 12V19H15C15.5523 19 16 18.5523 16 18V12","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const LettersBIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'letters-b',
    ref,
    icon: element,
  },
));

LettersBIcon.displayName = 'LettersBIcon';

export default LettersBIcon;
